<template>
    <div class="box tqmInfo">
        <div class="box-head bg-color1 flex-algin">
            <el-page-header @back="goBack" :content="secondTitle" style="color:#AECFDC;width:300px;"></el-page-header>
            <!-- <p class="color2" style="flex:1;text-align: left;">1#楼基础模板支护分项验收</p>
            <p class="color3" style="width:180px;text-align: right;">更多统计<i class="el-icon-arrow-right" style="margin-left:10px;"></i></p> -->
        </div>
        <div class="box-table">
            <div class="con-item color4">
                <p>项目选择：</p>
                <el-select v-model="opt.projectId" filterable placeholder="请选择" class="tqmInfo-val" @change="filterPro">
                    <el-option
                    v-for="item in projects"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="con-item-area bg-color5 color2">
                <div>
                    <p>验收内容：</p>
                    <el-input
                        type="textarea"
                        :rows="10"
                        placeholder="请输入内容"
                        v-model="opt.acceptanceContent">
                    </el-input>
                </div>
                <div>
                    <p>验收结果：</p>
                    <el-input
                        type="textarea"
                        :rows="10"
                        placeholder="请输入内容"
                        v-model="opt.acceptanceResult">
                    </el-input>
                </div>
                <div>
                    <p>验收人及附件:</p>
                    <p class="flex-algin">
                        <span style="display: inline-block;width:100px;">附件</span>
                        <img src="../../assets/image/upload.png" @click="addFile" style="width:32px;height:24px;" />
                    </p>
                    <p class="flex-algin" v-for="item in accepty" :key="item.id">
                        <span style="display: inline-block;width:100px;">验收人</span>
                        <el-input v-model="item.name" style="background: rgba(112, 112, 112, 0.3);width: 180px;"></el-input>
                        <i v-if="item.isAdd" class="el-icon-circle-plus-outline" @click="addPerson" style="color:#fff;font-size:30px;margin-left:10px;cursor: pointer;"></i>
                    </p>
                    <p class="flex-algin" style="justify-content: center;" v-if="id==''">
                        <el-button type="warning" class="bg-color3 color4" @click="addTqm(1)">不达标</el-button>
                        <el-button type="primary" @click="addTqm(0)">达标</el-button>
                    </p>
                    <p class="flex-algin" style="justify-content: center;" v-else>
                        <el-button type="warning" class="bg-color3 color4"  v-if="opt.standardStatus=='1'">不达标</el-button>
                        <el-button type="primary" v-else >达标</el-button>
                    </p>
                </div>
            </div>
            <div class="con-item color4 flex-wrap">
                <p class="color5" style="width:100%;">已验收事项</p>
                <hr style="width:100%;color:#707070;background:#707070;">
                <div style="width:100%;">
                    <div class="list-item bg-color5 color2" v-for="item in matters" :key="item.id">
                        <div style="width:20%;position: relative;">
                            <p class="nowrap flex-algin" style="width:100%;" :title="item.acceptanceContent">{{item.acceptanceContent}}</p>
                            <p class="flex-algin">验收时间：{{item.createDate}}</p>
                        </div>
                        <div style="flex:1;display:flex;">
                            <p style="width:150px;display: inline-block;">验收结果：</p>
                            <el-input
                                type="textarea"
                                :rows="5"
                                readonly
                                v-model="item.acceptanceResult">
                            </el-input>
                        </div>
                        <div style="display:flex;width:30%;padding-left:30px;">
                            <p style="width:150px;display: inline-block;">验收人：</p>
                            <p style="height:100px;flex:1;">{{item.personName}}</p>
                        </div>
                        <div class="flex-algin" style="width:150px;">
                            <el-button type="primary" style="background:#4D7BF4;" v-if="item.standardStatus=='0'">达标</el-button>
                            <el-button type="primary" style="background:#FFBC01;color:#fff;" v-else>不达标</el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
            title="上传附件"
            :visible.sync="dialogVisible"
            width="600px">
            <div style="flex:1;display:flex;flex-wrap: wrap;" class="item-con">
                <div style="width:100px;display:flex;flex-wrap:wrap;align-content: flex-start;" v-for="item in fileList" :key="item.url">
                    <!-- <p class="title nowrap" style="width:100%;" :title="child.attachmentName">{{child.attachmentName}}</p> -->
                    <p  style="width:100%;">
                        <img v-if="item.fileType=='1'" style="width:50px;height:50px;" src="../../assets/image/office/word.png" @click="showFile(item.url)" />
                        <img v-else-if="item.fileType=='2'" style="width:50px;height:50px;" src="../../assets/image/office/excel.png" @click="showFile(item.url)" />
                        <img v-else-if="item.fileType=='3'" style="width:50px;height:50px;" src="../../assets/image/office/pdf.png" @click="showFile(item.url)" />
                        <img v-else-if="item.fileType=='4'" style="width:50px;height:50px;" src="../../assets/image/office/photo.png" @click="showFile(item.url)" />
                        <img v-else-if="item.fileType=='5'" style="width:50px;height:50px;" src="../../assets/image/office/undefined.png" @click="showFile(item.url)" />
                    </p>
                    <p  style="width:100%;">{{item.name}}</p>
                    <!-- <p class="name" style="width:100%;">{{child.userName}}上传</p>
                    <p class="time" style="width:100%;">{{child.createDate}}</p> -->
                </div>
                <div style="width:150px;display:flex;flex-wrap:wrap;align-content: flex-start;justify-content: center;align-items: center;padding-top: 45px;">
                    <el-upload
                        class="upload-demo"
                        v-bind:action="uploadUrl"
                        :headers="uploadHead"
                        :data={type:215}
                        :show-file-list="false"
                        :on-success="fileSuccess">
                        <el-button size="small" class="primary">点击上传</el-button>
                    </el-upload>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import util from '../../untils/util';
import myHttp from '../../untils/port';
import base from '../../untils/base';
export default {
    data(){
        return{
            groupId:'',
            secondTitle:'分项验收',
            projects:[],
            opt:{
                projectId:'',          //项目id
                acceptanceType:'',     //验收类型,0分项验收，1分部验收
                acceptanceContent:'',  //验收内容
                acceptanceResult:'',   //验收结果
                annexAddresses:'',     //附件地址
                standardStatus:'',     //达标状态，0达标，1未达标
                personName:'',         //验收人姓名,多个用,隔开
                entId:'',
            },
            matters:[], //验收事项列表
            accepty:[
                {name:'',isAdd:true},
            ],   //验收人
            type:'',
            id:'',
            dialogVisible:false,
            uploadUrl:base.url+"/upload/uploadPhoto",//上传地址
            uploadHead:{  //上传接口header
                accessToken:this.$store.state.token
            },
            fileList:[],
        }
    },
    mounted(){
        this.groupId = this.$store.state.groupId
        if ('' == this.groupId || undefined == this.groupId) {
            this.groupId = util.session.get('groupId')
        }
        this.id = this.$route.params.id=='0'?'':this.$route.params.id
        this.type = this.$route.params.type=='-1'?'':this.$route.params.type
        this.opt.acceptanceType = this.type
        if(this.id==''){
            this.secondTitle = this.type=='0'?'质量分项验收管理':'质量分部验收管理'
        }else{
            this.secondTitle = this.type=='0'?'质量分项验收管理':'质量分部验收管理'
            this.getInfo()
        }
        this.getProject()
    },
    methods:{
        //获取质量管理详情    accepty
        getInfo(){
            var that = this
            myHttp.secAcceptanceRecord({
                id:this.id,
                joinType:'2',
                acceptanceType:this.type,
                entId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.list.list||[]
                    if(list.length>0){
                        that.opt.projectId = list[0].projectId
                        that.opt.acceptanceContent = list[0].acceptanceContent
                        that.opt.acceptanceResult = list[0].acceptanceResult
                        that.opt.annexAddresses = list[0].annexAddresses
                        that.opt.standardStatus = list[0].standardStatus
                        that.opt.personName = list[0].personName
                        var person = list[0].personName.split(',')
                        that.accepty = []
                        for(var i=0;i<person.length;i++){
                            var obj = {
                                name:person[i],
                                isAdd:false
                            }
                            if((person.length-1)==i){
                                obj.isAdd = true
                            }
                            that.accepty.push(obj)
                        }
                        if(list[0].annexAddresses!=''){
                            var files = list[0].annexAddresses.split(',')
                            for(var i=0;i<files.length;i++){
                                var obj = {}
                                obj.url = files[i]
                                obj.fileType = that.getImg(obj.url)
                                obj.name = '';
                                that.fileList.push(obj)
                            }
                        }
                        that.filterPro()
                    }
                }else{

                }
            })
        },
        //获取项目
        getData(){
            var that = this;
            myHttp.getProjectById({
                id: this.groupId
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var project = resp.data.data.project;
                    that.secondTitle = project.name
                } else {
                    that.$message.error(resp.data.msg)
                }
            },function() {})
        },
        goBack(){
            this.$router.go(-1)
            //window.history.back()
        },
        //获取所有的项目
        getProject(){
            var that = this
            myHttp.getProjectListByEntIdAndJoinType({
                entId:this.groupId,
                joinType:'2'
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    that.projects = list
                }
            })
        },
        //添加
        addTqm(str){
            this.opt.standardStatus = str
            this.opt.personName = ''
            var person = this.accepty
            for(var i=0;i<person.length;i++){
                if(person[i].name!=''){
                    if(this.opt.personName==''){
                        this.opt.personName = person[i].name
                    }else{
                        this.opt.personName += ','+ person[i].name
                    }
                }
            }
            //获取数据
            var files = this.fileList
            for(var i=0;i<files.length;i++){
                if(files[i].url!=''){
                    if(this.opt.annexAddresses==''){
                        this.opt.annexAddresses = files[i].url
                    }else{
                        this.opt.annexAddresses += ','+files[i].url
                    }
                }
            }
            this.opt.entId = this.groupId
            var that = this
            myHttp.addAcceptance(this.opt).then(function(resp){
                if(resp.data.code=='200'){
                    that.$message.success('添加成功')
                    that.$router.push({ path: '/tqm' })
                }else{
                    that.$message.error(resp.data.msg)
                }
            })
        },
        //监听上传成功
        fileSuccess(res,file,opt,index){
            if(res.code==200){
                var obj = {}
                obj.url = res.data.saveUrls
                obj.fileType = this.getImg(obj.url)
                var name = file.name.split('.')
                name.pop()
                obj.name = name.join();
                this.fileList.push(obj)
            }else{
                that.$message.error(resp.data.msg)
            }
        },
        //获取图片
        getImg(url){
            // 1:word   2:excel    3:pdf     4:img   5:undefined
            var result = '';
            var list = url.split('.')
            var str = list[list.length-1]
            if(base.docType.indexOf(str)>=0){
                result = '1'
            }else if(base.imgType.indexOf(str)>=0){
                result = '4'
            }else if(base.excelType.indexOf(str)>=0){
                result = '2'
            }else if(base.pdfType.indexOf(str)>=0){
                result = '3'
            }else{
                result = '5'
            }
            return result
        },
        //查看
        showFile(url){
            window.open(base.fileView+'/onlinePreview?url='+encodeURIComponent(base.httpCtx+url),"_blank");
        },
        //添加验收人
        addPerson(){
            this.accepty.push({name:'',isAdd:false})
            for(var i=0;i<this.accepty.length;i++){
                if(i==this.accepty.length-1){
                    this.accepty[i].isAdd = true
                }else{
                    this.accepty[i].isAdd = false
                }
            }
        },
        // 监听项目
        filterPro(){
            var that = this
            myHttp.secAcceptanceRecord({
                entId:this.groupId,
                joinType:'2',
                acceptanceType:this.type,
                projectId:this.opt.projectId
            }).then(function(resp){
                if (resp.data.code == '200') {
                    var list = resp.data.data.list || []
                    //var result = []
                    for(var i=0;i<list.length;i++){
                        //list[i].index = ((that.currentPage - 1) * that.pageSize)+(i+1);
                        list[i].index = i+1
                    }
                    that.matters = list
                }
            })
        },
        //添加上传图片
        addFile(){
            this.dialogVisible = true
        },
    },
}
</script>
<style scoped>
    *{
        box-sizing: border-box;
    }
    .box{
        width: 100%;
        position: relative;
        height: 100%;
        background: #010D27;
    }
    .box-head{
        width: 100%;
        height: 40px;
        position: relative;
        display: flex;
        padding: 0 20px;
        font-size: 18px;
    }
    .box-table{
        width: 100%;
        height: calc( 100% - 40px );
        position: relative;
        padding: 20px;
        box-sizing: border-box;
        font-size: 18px;
        overflow: auto;
    }
    .el-table .box-head-title{
        font-size: 16px;
    }
    .con-item{
        display: flex;
        justify-content: left;
        align-items: center;
        margin-bottom: 15px;
    }
    .con-item-area{
        width: 100%;
        display: flex;
        padding: 10px 10px 20px;
        font-size: 18px;
        margin-bottom: 20px;
    }
    .con-item p,.con-item-area p{
        padding: 10px 15px 10px 15px;
        text-align: left;
        margin: 0;
    }
    .con-item-area>div:nth-child(1){
        width: 400px;
        padding: 0 20px 0 20px;
    }
    .con-item-area>div:nth-child(2){
        width: calc( 100% - 800px );
        padding: 0 20px 0 20px;
    }
    .con-item-area>div:nth-child(3){
        width: 400px;
        padding: 0 20px 0 20px;
        height: 300px;
        overflow: auto;
    }
    .tqmInfo .list-item{
        display: flex;
        height: 120px;
        width: 100%;
        margin-bottom: 20px;
    }
    

    .flex-wrap{
        display:flex;
        flex-wrap: wrap;
    }
    .flex-algin{
        display: flex;
        align-content: center;
        align-items: center;
    }
    .felx-between{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .tqmInfo .bg-color1{
        background: #001498;
    }
    .tqmInfo .bg-color2{
        background: #0D2DFF;
    }
    .tqmInfo .bg-color3{
        background: #FFBC01;
    }
    .tqmInfo .bg-color4{
        background: #36C635;
    }
    .tqmInfo .bg-color5{
        background: #011C56;
    }
    .tqmInfo .color1{
        color: #17B2FE;
    }
    .tqmInfo .color2,.tqmInfo .color2 span{
        color: #4D7BF4;
    }
    .tqmInfo .color3{
        color: #4C9AFF;
    }
    .tqmInfo .color4{
        color: #fff;
    }
    .tqmInfo .color5{
        color: #36C635;
    }
    .nowrap {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
</style>
<style>
    .tqmInfo .el-page-header__content{
      color: inherit;
    }
    .el-input__inner{
        background: transparent;
        border: 0;
    }
    .tqmInfo .el-textarea__inner{
        color: inherit;
        background: rgba(112, 112, 112, 0.3);
        border: 0;
        color: #4D7BF4;
    }
    .tqmInfo .color4 span,.tqmInfo .el-input__inner{
        color: #fff;
    }
</style>